import LegalPageLayout from '../../components/LegalPageLayout'

export default function TermsAndConditions() {
  return (
    <LegalPageLayout title="Terms and Conditions" lastUpdated="February 6, 2026">
      <div className="space-y-6">
        <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 mb-8">
          <p className="text-sm text-gray-700">
            <strong>PLACEHOLDER DOCUMENT:</strong> This document contains placeholder legal text. 
            You must have this reviewed and customized by a qualified legal professional before going live. 
            This is not legal advice.
          </p>
        </div>

        <section>
          <h2 className="text-2xl font-bold text-gray-900 mb-4">1. Acceptance of Terms</h2>
          <p className="text-gray-700 mb-4">
            By accessing and using the LoanLoop website ("Website"), you accept and agree to be bound by these Terms and Conditions. 
            If you do not agree with these terms, you must not use this Website.
          </p>
          <p className="text-gray-700">
            These terms may be updated from time to time. Your continued use of the Website constitutes acceptance of any modifications.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-bold text-gray-900 mb-4">2. Nature of Service</h2>
          <p className="text-gray-700 mb-4">
            <strong>LoanLoop is a Comparison Service Only.</strong> We provide:
          </p>
          <ul className="list-disc pl-6 text-gray-700 space-y-2">
            <li>Information and comparison tools for mortgage products</li>
            <li>Display of published loan rates from various lenders</li>
            <li>Calculators and educational resources</li>
          </ul>
          <p className="text-gray-700 mt-4">
            <strong>We DO NOT:</strong>
          </p>
          <ul className="list-disc pl-6 text-gray-700 space-y-2">
            <li>Provide credit or lending services</li>
            <li>Approve or reject loan applications</li>
            <li>Provide financial advice or recommendations</li>
            <li>Act as a credit provider or intermediary</li>
            <li>Guarantee any rates, terms, or loan approvals</li>
          </ul>
        </section>

        <section>
          <h2 className="text-2xl font-bold text-gray-900 mb-4">3. Rate and Information Accuracy</h2>
          <p className="text-gray-700 mb-4">
            <strong className="text-red-600">IMPORTANT:</strong> All interest rates, fees, and loan terms displayed on this Website are:
          </p>
          <ul className="list-disc pl-6 text-gray-700 space-y-2 mb-4">
            <li><strong>Indicative only</strong> - based on publicly available information at the time of publication</li>
            <li><strong>Subject to change</strong> - lenders may modify rates and offers at any time without notice</li>
            <li><strong>Not guaranteed</strong> - actual rates may differ based on your individual circumstances</li>
            <li><strong>Requires verification</strong> - you must confirm current rates directly with lenders before proceeding</li>
          </ul>
          <p className="text-gray-700">
            We make reasonable efforts to keep information current, but we do not warrant the accuracy, completeness, 
            or timeliness of any information displayed. Rates shown may not reflect the most current offerings.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-bold text-gray-900 mb-4">4. No Lending Relationship</h2>
          <p className="text-gray-700 mb-4">
            Use of this Website does not create any credit agreement, lending relationship, or contractual obligation 
            between you and LoanLoop. Any loan application or credit agreement is solely between you and the chosen lender.
          </p>
          <p className="text-gray-700">
            Lenders have sole discretion to approve or reject applications based on their own criteria. 
            LoanLoop has no influence over lending decisions.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-bold text-gray-900 mb-4">5. Not Financial Advice</h2>
          <p className="text-gray-700 mb-4">
            <strong>The information on this Website is general in nature and does not constitute financial advice.</strong>
          </p>
          <p className="text-gray-700 mb-4">
            We do not consider your personal financial situation, objectives, or needs. Before making any financial decisions, 
            you should:
          </p>
          <ul className="list-disc pl-6 text-gray-700 space-y-2">
            <li>Seek independent financial advice from a qualified professional</li>
            <li>Read all product disclosure statements and terms from lenders</li>
            <li>Verify current rates and conditions directly with lenders</li>
            <li>Consider whether any product is appropriate for your circumstances</li>
          </ul>
        </section>

        <section>
          <h2 className="text-2xl font-bold text-gray-900 mb-4">6. Limitation of Liability</h2>
          <p className="text-gray-700 mb-4">
            To the maximum extent permitted by law, LoanLoop and its operators shall not be liable for:
          </p>
          <ul className="list-disc pl-6 text-gray-700 space-y-2">
            <li>Any inaccuracies, errors, or omissions in displayed information</li>
            <li>Changes to rates, fees, or terms by lenders</li>
            <li>Loan application rejections or approvals</li>
            <li>Financial losses arising from use of this Website</li>
            <li>Decisions made based on information displayed</li>
            <li>Third-party lender actions or policies</li>
            <li>Website downtime or technical issues</li>
          </ul>
          <p className="text-gray-700 mt-4">
            You use this Website entirely at your own risk.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-bold text-gray-900 mb-4">7. Third-Party Content</h2>
          <p className="text-gray-700">
            Information about loan products is sourced from lender publications and public data. 
            LoanLoop does not control or endorse third-party content. We are not responsible for 
            the accuracy, availability, or reliability of information from external sources.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-bold text-gray-900 mb-4">8. User Responsibilities</h2>
          <p className="text-gray-700 mb-4">
            When using this Website, you agree to:
          </p>
          <ul className="list-disc pl-6 text-gray-700 space-y-2">
            <li>Verify all information independently before making decisions</li>
            <li>Contact lenders directly for current, accurate information</li>
            <li>Not rely solely on displayed rates or information</li>
            <li>Seek professional advice for your specific situation</li>
            <li>Use the Website in accordance with applicable laws</li>
          </ul>
        </section>

        <section>
          <h2 className="text-2xl font-bold text-gray-900 mb-4">9. Intellectual Property</h2>
          <p className="text-gray-700">
            All content on this Website, including design, logos, text, and software, is owned by LoanLoop 
            or licensed to us. You may not reproduce, distribute, or create derivative works without our written permission.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-bold text-gray-900 mb-4">10. Governing Law</h2>
          <p className="text-gray-700">
            These Terms and Conditions are governed by the laws of Australia. Any disputes shall be subject to 
            the exclusive jurisdiction of the Australian courts.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-bold text-gray-900 mb-4">11. Contact Information</h2>
          <p className="text-gray-700">
            For questions about these Terms and Conditions:
          </p>
          <div className="mt-4 p-4 bg-gray-50 rounded-md">
            <p className="text-gray-700"><strong>Email:</strong> legal@loanloop.com.au</p>
            <p className="text-gray-700"><strong>Address:</strong> [Your Business Address]</p>
            <p className="text-gray-700"><strong>ABN:</strong> [Your ABN]</p>
          </div>
        </section>

        <div className="mt-8 p-6 bg-red-50 border-l-4 border-red-400">
          <p className="text-sm text-gray-700">
            <strong>LEGAL REVIEW REQUIRED:</strong> This document is a placeholder template only. 
            It must be reviewed, customized, and approved by a qualified legal professional before publication. 
            Consult with a lawyer specializing in Australian financial services and consumer law.
          </p>
        </div>
      </div>
    </LegalPageLayout>
  )
}
